import CustomButton from "components/CustomButton/CustomButton";
import SpaceDialogAction from "../SpaceDialogAction"

const DialogAddStudentConfirmation = ({
	dialog, space, studentsSelectedToUse,
	addStudentToReservationList
}) => {
	return (
		<SpaceDialogAction
			dialog={dialog}
			title={`¿Deseas agregar al alumno ${studentsSelectedToUse[0]?.id} (${studentsSelectedToUse[0]?.name})
			de la reserva del espacio ${space.name}?`}
			content="Recuerda que al agregar un alumno, podrás visualizarlo nuevamente en el listado de alumnos.">
			<CustomButton
				variant="secondary"
				width="120px"
				text="No, cancelar"
				onClick={dialog.hide} />
			<CustomButton
				width="120px"
				text="Si, agregar"
				onClick={addStudentToReservationList} />
		</SpaceDialogAction>
	);
}

export default DialogAddStudentConfirmation;